import { ImgHTMLAttributes } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { media } from '@clds/style-utils';
import withCheckerboardBackground from '@cld/with-checkerboard-background';

export const PillsLayout = styled.div<{ distanced: boolean }>`
  margin: ${(props) => (props.distanced ? globalTheme.spacing.lg : '0')} 0;
  flex-shrink: 0;

  @media ${media.wide()} {
    width: 100%;
    margin-top: ${globalTheme.spacing.xs};
  }
`;

export const Header = styled.div`
  color: ${globalTheme.palette.contrastHigh};
  font-size: ${globalTheme.font.size.lg};
  font-weight: 500;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${globalTheme.spacing.xs};
  
  @media ${media.wide()} {
    flex-wrap: wrap;
`;

export const Thumbnail = withCheckerboardBackground(styled.img`
  width: 200px;
  height: 200px;
  margin: 0 auto;
  padding: ${globalTheme.spacing.md};
  border-radius: ${globalTheme.radius.lg};
  object-fit: cover;
  object-position: center center;
`);

export const RowLayout = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin: auto 0 0 0;

  > button {
    margin-top: ${globalTheme.spacing.sm};
  }
`;
